import { render } from "./ReportDetailsPage.vue?vue&type=template&id=e655798e&scoped=true"
import script from "./ReportDetailsPage.vue?vue&type=script&lang=js"
export * from "./ReportDetailsPage.vue?vue&type=script&lang=js"

import "./ReportDetailsPage.vue?vue&type=style&index=0&id=e655798e&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e655798e"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QBtn,QBanner,QLinearProgress,QTabs,QTab,QTabPanels,QTabPanel});
